<template>
  <div class="home">
    <div class="videoBody" v-show="showVideo" ref="videoBody">
      <video
        id="example_video"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        autoplay
        :controls="true"
        muted
        loop
        class="fillWidth video-js"
        webkit-playsinline 
        playsinline 
        preload="auto"
        :style="videoStyle"
      >
        <source src="https://tfile.melinked.com/2024/02/04c7b836-b589-40d0-a0ca-f8a7105aaabc.mp4" type="video/mp4"/>
      </video>
    </div>
    <div class="videoPlaceholder" v-show="!showVideo"
      :style="{ width: '100%', height: videoBodyHeight ? videoBodyHeight + 'px' : '56.25vw' }">
      <img src="../assets/images/home/home-logo.png" alt="MaesInfo" class="placeholderLogo">
    </div>
    <swiper :options="swiperOption" ref="mySwiper" class="banner">
      <swiper-slide v-for="(banner,key) in $t('home.banners')" :key="key" :style="{'background':'url('+banner.imgUrl+')','background-size': 'cover'}">
        <p class="title">{{titleToUpperCase(banner.title)}}</p>
        <p class="description">{{banner.description}}</p>
      </swiper-slide>
      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>
     <!-- 服务前7 -->
    <div class="services">
      <div class="labelTitle">
        {{titleToUpperCase($t('home.serviceTitle'))}}
      </div>
      <div class="itemsList">
        <div class="line">
          <div class="item" :style="{'background': 'url('+ $t('home.services[0].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[0].component'))" :class="$t('home.services[0].size')">
            <div class="text">
               <p class="title">{{$t('home.services[0].title')}}</p>
               <p class="description">{{$t('home.services[0].description')}}</p>
            </div>
          </div>
          <div class="item" :style="{'background': 'url('+ $t('home.services[1].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[1].component'))" :class="$t('home.services[1].size')">
            <div class="text">
               <p class="title">{{$t('home.services[1].title')}}</p>
               <p class="description">{{$t('home.services[1].description')}}</p>
            </div>
          </div>
          <div class="item" :style="{'background': 'url('+ $t('home.services[2].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[2].component'))" :class="$t('home.services[2].size')">
            <div class="text">
               <p class="title">{{$t('home.services[2].title')}}</p>
               <p class="description">{{sliceDescription($t('home.services[2].description'),130)}}</p>
            </div>
          </div>
        </div>
        <div class="line">
          <div class="item" :style="{'background': 'url('+ $t('home.services[3].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[2].component'))" :class="$t('home.services[2].size')">
            <div class="text">
               <p class="title">{{$t('home.services[3].title')}}</p>
               <p class="description">{{sliceDescription($t('home.services[3].description'),130)}}</p>
            </div>
          </div>
          <div class="item" :style="{'background': 'url('+ $t('home.services[4].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[4].component'))" :class="$t('home.services[4].size')">
            <div class="text">
               <p class="title">{{$t('home.services[4].title')}}</p>
               <p class="description">{{sliceDescription($t('home.services[4].description'),125)}}</p>
            </div>
          </div>
          <div class="item" :style="{'background': 'url('+ $t('home.services[5].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[5].component'))" :class="$t('home.services[5].size')">
            <div class="text">
               <p class="title">{{$t('home.services[5].title')}}</p>
               <p class="description">{{sliceDescription($t('home.services[5].description'),80)}}</p>
            </div>
          </div>
        </div>
        <div class="line">
          <div class="item" :style="{'background': 'url('+ $t('home.services[6].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[6].component'))" :class="$t('home.services[6].size')">
            <div class="text">
               <p class="title">{{$t('home.services[6].title')}}</p>
               <p class="description">{{sliceDescription($t('home.services[6].description'),230)}}</p>
            </div>
          </div>
          <div class="item" :style="{'background': 'url('+ $t('home.services[7].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[7].component'))" :class="$t('home.services[7].size')">
            <div class="text">
               <p class="title">{{$t('home.services[6].title')}}</p>
               <p class="description">{{sliceDescription($t('home.services[7].description'),190)}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 行业 -->
    <div class="industry">
      <label class="labelTitle">{{$t('home.industryTitle')}}</label>
      <ul class="itemsList">
         <!-- @click="jumpPage(item.component)" -->
         <li class="item" v-for="(item,key) in $t('home.industry')" :key="key" @click="jumpPage(item.component)">
           <!-- <span class="icon" :style="{'background':'url('++')', 'backgroundSize': 'cover'}"></span> -->
           <img class="icon" :src="item.icon" alt="">
           <span class="title">{{titleToUpperCase(item.title)}}</span>
         </li>
      </ul>
    </div>
    <!-- 服务 7-14 -->
    <div class="service7-14">
      <div class="itemsList">
        <div class="line">
          <div class="item" :style="{'background': 'url('+ $t('home.services[7].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[7].component'))" :class="$t('home.services[7].size')">
            <div class="text">
               <p class="title">{{$t('home.services[7].title')}}</p>
               <p class="description">{{$t('home.services[7].description')}}</p>
            </div>
          </div>
          <div class="item" :style="{'background': 'url('+ $t('home.services[8].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[8].component'))" :class="$t('home.services[8].size')">
            <div class="text">
               <p class="title">{{$t('home.services[8].title')}}</p>
               <p class="description">{{$t('home.services[8].description')}}</p>
            </div>
          </div>
        </div>
        <div class="line">
          <div class="item" :style="{'background': 'url('+ $t('home.services[9].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[9].component'))" :class="$t('home.services[9].size')">
            <div class="text">
               <p class="title">{{$t('home.services[9].title')}}</p>
               <p class="description">{{$t('home.services[9].description')}}</p>
            </div>
          </div>
          <div class="item" :style="{'background': 'url('+ $t('home.services[10].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[10].component'))" :class="$t('home.services[10].size')">
            <div class="text">
               <p class="title">{{$t('home.services[10].title')}}</p>
               <p class="description">{{$t('home.services[10].description')}}</p>
            </div>
          </div>
        </div>
        <div class="line">
          <div class="item" :style="{'background': 'url('+ $t('home.services[11].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[11].component'))" :class="$t('home.services[11].size')">
            <div class="text">
               <p class="title">{{$t('home.services[11].title')}}</p>
               <p class="description">{{$t('home.services[11].description')}}</p>
            </div>
          </div>
          <div class="item" :style="{'background': 'url('+ $t('home.services[12].imgUrl')+')','backgroundSize': 'cover'}" @click="jumpPage($t('home.services[12].component'))" :class="$t('home.services[12].size')">
            <div class="text">
               <p class="title">{{$t('home.services[12].title')}}</p>
               <p class="description">{{$t('home.services[12].description')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "home",
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination"
        },
        autoplay: true
      },
      isWechat: false,
      soundStatus: false,
      videoStyle: {},
      showVideo: true,
      videoBodyHeight: 0
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted() {
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      this.videoStyle = {
        width: "100%",
        height: "auto"
      };
    } else {
      this.videoStyle = {
        width: "100%",
        height: "calc(100vh - 62px)"
      };
    }
    this.$nextTick(() => {
      let video = document.getElementById("example_video");
      let userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("micromessenger") !== -1) {
        this.isWechat = true;
      } else {
        this.isWechat = false;
      }
      video.play();
    });
    // 监听导航/语言面板开关，H5 下隐藏/显示视频
    this.$root.$on('h5VideoVisibility', (visible) => {
      if (!visible && this.$refs.videoBody) {
        // 隐藏前记录视频区域的实际高度，传给占位图
        this.videoBodyHeight = this.$refs.videoBody.offsetHeight
      } else {
        this.videoBodyHeight = 0
      }
      this.showVideo = visible
    })
  },
  beforeDestroy() {
    this.$root.$off('h5VideoVisibility')
  },
  methods: {
    playSound() {
      let video = document.getElementById("example_video");
      if (this.soundStatus) {
        video.muted = false;
      } else {
        video.muted = true;
      }
      this.soundStatus = !this.soundStatus;
    }
  }
};
</script>
<style lang="less" src="../assets/css/home.less">
</style>
<style lang="less" scoped>
.videoPlaceholder {
  width: 100%;
  background: #050e2b;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;

  .placeholderLogo {
    width: 120px;
    opacity: 0.6;
  }
}
</style>
